/* src/app/views/legal-text-contract/legal-text-contract-chile/legal-text-contract-chile.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 20px 32px;
  margin: 0 auto 24px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
}
.article {
  column-count: 2;
  column-gap: 2rem;
  column-rule: 3px;
}
.title-terminos {
  position: relative;
  left: -1.5em;
  padding-bottom: 20px;
  font-weight: bold;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title-padding {
  padding: 2px;
}
.text-initial {
  position: relative;
  left: -1.5em;
  font-size: 10pt;
  margin-bottom: 30px;
}
.sub-title {
  position: relative;
  padding-top: 10px;
  left: -1em;
}
.custom-list-roman {
  list-style: none;
  counter-reset: custom-counter;
  padding-left: 1em;
}
.custom-list-roman .li-roman {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
}
.custom-list-roman .li-roman:before {
  position: absolute;
  left: -2.5em;
  counter-increment: custom-counter;
  content: "(" counter(custom-counter, upper-roman) ") ";
}
.custom-list-number {
  list-style: none;
  counter-increment: main-counter;
  padding-left: 0;
}
.custom-list-number .li-number {
  position: relative;
  padding-top: 10px;
  padding-left: 1em;
  font-size: 10pt;
  counter-increment: sub-counter;
}
.custom-list-number .li-number:before {
  position: absolute;
  left: -1em;
  content: counters(main-counter, ".") "." counters(sub-counter, ".") ". ";
}
.ul-ifem {
  list-style: none;
  padding-top: 10px;
  padding-left: 2em;
}
.ul-ifem .li-ifem {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
}
.ul-ifem .li-ifem:before {
  position: absolute;
  content: "-";
  margin-right: 5px;
  left: -2em;
}
.custom-list-text {
  position: relative;
  left: -1em;
  list-style: none;
}
.custom-list-text .li-text {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
}
.custom-list-number .li-text:before {
  position: absolute;
  margin-right: 5px;
}
.custom-list-alphabet {
  list-style: none;
  padding-top: 10px;
  padding-left: 3em;
}
.custom-list-alphabet .li-alphabet {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
  counter-increment: custom-counter;
}
.custom-list-alphabet .li-alphabet:before {
  position: absolute;
  content: counter(custom-counter, lower-alpha) ") ";
  margin-right: 5px;
  left: -3em;
}
.span-negrito {
  font-weight: bold;
}
.title-negrito {
  font-weight: bold;
}
.span-underlined {
  text-decoration: underline;
}
.a-edit {
  color: #000000;
}
.a-edit:hover,
.a-edit-blue:hover {
  color: #008de2;
}
.a-edit-blue {
  color: #0062af;
}
/*# sourceMappingURL=legal-text-contract-chile.component-XPV3OUNA.css.map */
